import React from 'react';
import { Link } from 'react-router-dom';
import StarBorder from './StarBorder';

const Hero = () => {
    return (
        <section className="hero-liquid" aria-label="Presentación">
            <div className="hero-liquid__ambient" aria-hidden="true">
                <div className="hero-blob hero-blob--1" />
                <div className="hero-blob hero-blob--2" />
                <div className="hero-blob hero-blob--3" />
                <div className="hero-glass-orb hero-glass-orb--a" />
                <div className="hero-glass-orb hero-glass-orb--b" />
            </div>

            <div className="container-fluid hero-liquid__grid px-3 px-lg-4">
                <aside className="hero-social-rail d-none d-lg-flex" aria-label="Enlaces sociales">
                    <a href="https://www.linkedin.com/in/benjamin-mendez-09427a2a4" className="hero-social-rail__link" target="_blank" rel="noopener noreferrer">in</a>
                    <Link to="/cv" className="hero-social-rail__link">cv</Link>
                    <a href="mailto:bemendez@alumnos.uai.cl" className="hero-social-rail__link">@</a>
                </aside>

                <div className="hero-visual">
                    <div className="hero-bg-name" aria-hidden="true">
                        <span className="hero-bg-name__line">Benjamín</span>
                        <span className="hero-bg-name__line">Méndez</span>
                    </div>
                    <div className="hero-visual__glow" aria-hidden="true" />
                    <img
                        src="/images/fotobenja.png"
                        alt="Benjamín Méndez"
                        className="hero-visual__img"
                        width={560}
                        height={720}
                    />
                </div>

                <div className="hero-copy">
                    <p className="hero-eyebrow">
                        <span className="hero-eyebrow__line" aria-hidden="true" />
                        Ingeniero Civil Industrial
                    </p>
                    <h1 className="hero-title">
                        En Chile, combino ingeniería de procesos, datos y mejora continua.
                    </h1>
                    <p className="hero-lead text-white-50">
                        Optimización operacional, Lean y Six Sigma: diseño soluciones que reducen desperdicio y apoyan decisiones con evidencia.
                    </p>
                    <div className="hero-actions">
                        <StarBorder
                            as="a"
                            href="#experience"
                            innerClassName="btn hero-btn-glass"
                            color="rgba(126, 189, 203, 0.4)"
                            speed="10s"
                        >
                            Experiencia
                        </StarBorder>
                        <StarBorder
                            as="a"
                            href="#contact"
                            innerClassName="btn hero-btn-ghost"
                            color="rgba(200, 220, 228, 0.28)"
                            speed="11s"
                        >
                            Contacto
                        </StarBorder>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
